export default __webpack_public_path__ + "static/media/rating_6.70f8c156.png";